import React, { useState } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Layout } from '../components'
import { Home, Activity, Account, Wallet, Promotion } from '../pages'
import Aviator from '../pages/games/Aviator'
import Mines from '../pages/games/Mines'
import Lottery from '../pages/games/Lottery'
import { WinGo, TrxWin, Racing, K3, FiveD } from '../pages/lotteryGames'

const Router = () => {
  const [makingDeposit, setMakingDeposit] = useState(false)
  const [ balance, setBalance ] = useState(263)
  return (
    <BrowserRouter>
      <Routes >
        <Route path='/aviator' element={<Aviator/>}/>
        <Route path='/mines' element={<Mines balance={balance} setBalance={setBalance}/>}/>
        <Route element={<Layout makingDeposit={makingDeposit} setMakingDeposit={setMakingDeposit} balance={balance} setBalance={setBalance}/>}>
        {
          //Core pages
        }
        <Route path='/' element={<Home balance={balance} setBalance={setBalance}/>}/>
        <Route path='/activity' element={<Activity balance={balance} setBalance={setBalance}/>}/>
        <Route path='/account' element={<Account/>}/>
        <Route path='/wallet' element={<Wallet/>}/>
        <Route path='/promo' element={<Promotion/>}/>
        {
          //Games
        }
        <Route path='/lottery' element={<Lottery/>}/>
        {
          //Lottery Games
        }
          <Route path='/lottery/wingo' element={<WinGo/>}/>
          <Route path='/lottery/trxwin' element={<TrxWin/>}/>
          <Route path='/lottery/racing' element={<Racing/>}/>
          <Route path='/lottery/k3' element={<K3/>}/>
          <Route path='/lottery/5D' element={<FiveD/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default Router